var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "US-UK_Apple_Music_Listen_on_Lockup_RGB_blk_072720",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.563,
    height: 22.576,
    viewBox: "0 0 104.563 22.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.996,
    x2: 0.5,
    y2: 0.022,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa233b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb5c74"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_262_",
    transform: "translate(25.517 9.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    d: "M36.929,18.993H32.935l-.961,2.832H30.28L34.064,11.35h1.753L39.6,21.825H37.881Zm-3.582-1.306h3.169l-1.559-4.593h-.042Z",
    transform: "translate(-30.28 -11.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    d: "M49.688,18.523c0,2.376-1.272,3.9-3.185,3.9a2.593,2.593,0,0,1-2.4-1.331h-.034v3.784H42.5V14.706h1.517v1.272h.025a2.717,2.717,0,0,1,2.435-1.348C48.407,14.622,49.688,16.155,49.688,18.523Zm-1.618,0c0-1.542-.8-2.562-2.014-2.562-1.2,0-2.006,1.037-2.006,2.562,0,1.542.809,2.57,2.006,2.57C47.278,21.094,48.07,20.082,48.07,18.523Z",
    transform: "translate(-32.202 -11.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_279_",
    d: "M59.648,18.523c0,2.376-1.272,3.9-3.185,3.9a2.593,2.593,0,0,1-2.4-1.331h-.034v3.784H52.46V14.706h1.517v1.272H54a2.717,2.717,0,0,1,2.435-1.348C58.367,14.622,59.648,16.155,59.648,18.523Zm-1.61,0c0-1.542-.8-2.562-2.014-2.562-1.2,0-2.006,1.037-2.006,2.562,0,1.542.809,2.57,2.006,2.57C57.238,21.094,58.039,20.082,58.039,18.523Z",
    transform: "translate(-33.769 -11.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_277_",
    d: "M62.49,11.35h1.567V21.825H62.49V11.35Z",
    transform: "translate(-35.346 -11.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_274_",
    d: "M72.745,20.094a3.064,3.064,0,0,1-3.287,2.334c-2.225,0-3.6-1.492-3.6-3.876S67.25,14.6,69.391,14.6c2.115,0,3.438,1.449,3.438,3.767v.539H67.436V19a1.99,1.99,0,0,0,2.056,2.166,1.729,1.729,0,0,0,1.761-1.07h1.492Zm-5.3-2.284h3.817a1.833,1.833,0,0,0-1.871-1.938A1.939,1.939,0,0,0,67.444,17.811Z",
    transform: "translate(-35.876 -11.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_272_",
    d: "M88.478,21.825V14.114h-.051l-3.16,7.627H84.062l-3.169-7.627h-.051v7.711H79.36V11.35h1.879l3.388,8.267h.059l3.379-8.267h1.888V21.825H88.478Z",
    transform: "translate(-38 -11.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_",
    d: "M100.622,22.355h-1.5V21.04h-.034a2.381,2.381,0,0,1-2.368,1.4,2.546,2.546,0,0,1-2.68-2.823v-4.9h1.567v4.593c0,1.163.548,1.778,1.635,1.778a1.767,1.767,0,0,0,1.812-1.972v-4.4h1.567v7.635Z",
    transform: "translate(-40.309 -11.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_268_",
    d: "M106.545,14.62c1.694,0,2.907.935,2.941,2.284h-1.475c-.067-.674-.64-1.087-1.508-1.087-.851,0-1.416.4-1.416.986,0,.455.379.758,1.171.961l1.281.295c1.542.371,2.115.935,2.115,2.056,0,1.382-1.306,2.326-3.169,2.326-1.8,0-3.008-.919-3.126-2.317h1.551c.11.733.7,1.129,1.652,1.129.935,0,1.525-.388,1.525-.994,0-.472-.287-.725-1.087-.927l-1.365-.337q-2.073-.506-2.073-2.1C103.554,15.539,104.767,14.62,106.545,14.62Z",
    transform: "translate(-41.775 -11.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_265_",
    d: "M112.28,12.162a.915.915,0,1,1,.91.893A.9.9,0,0,1,112.28,12.162Zm.126,2.014h1.567v7.635h-1.567Z",
    transform: "translate(-43.178 -11.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_263_",
    d: "M121.29,17.332a1.681,1.681,0,0,0-1.8-1.407c-1.205,0-2.006,1.011-2.006,2.6,0,1.626.809,2.6,2.014,2.6a1.651,1.651,0,0,0,1.787-1.374h1.508a3.057,3.057,0,0,1-3.312,2.68c-2.174,0-3.6-1.492-3.6-3.91,0-2.376,1.424-3.91,3.582-3.91a3.069,3.069,0,0,1,3.312,2.722Z",
    transform: "translate(-43.744 -11.787)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730",
    transform: "translate(26.014 0.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M34.055,6.587H30.87V1.48h.792V5.854h2.393Z",
    transform: "translate(-30.87 -1.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M35.74,1.523a.468.468,0,0,1,.489-.463.463.463,0,0,1,.489.463.468.468,0,0,1-.489.463A.463.463,0,0,1,35.74,1.523Zm.118,1.146h.758V6.521h-.758Z",
    transform: "translate(-31.636 -1.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M39.606,2.88c.868,0,1.433.4,1.508,1.079H40.39c-.067-.287-.346-.463-.775-.463s-.742.2-.742.506c0,.228.194.379.615.472l.64.152c.733.169,1.079.489,1.079,1.053,0,.725-.674,1.214-1.593,1.214S38.1,6.478,38.03,5.8h.758c.093.295.379.48.843.48s.809-.211.809-.522c0-.228-.177-.379-.565-.472L39.2,5.13c-.733-.177-1.07-.506-1.07-1.079C38.106,3.36,38.729,2.88,39.606,2.88Z",
    transform: "translate(-31.996 -1.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M43.914,1.83v.978h.834v.64h-.834v1.98c0,.4.169.581.548.581.118,0,.185-.008.287-.017v.632a2.142,2.142,0,0,1-.413.042c-.843,0-1.18-.295-1.18-1.037V3.448H42.54v-.64h.615V1.83Z",
    transform: "translate(-32.706 -1.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M49.517,5.76a1.567,1.567,0,0,1-1.669,1.112A1.75,1.75,0,0,1,46.07,4.884,1.779,1.779,0,0,1,47.848,2.87c1.07,0,1.719.733,1.719,1.938v.278H46.845v.042a1.022,1.022,0,0,0,1.028,1.1.933.933,0,0,0,.919-.463h.725ZM46.845,4.522h1.947a.926.926,0,0,0-.944-.994A.992.992,0,0,0,46.845,4.522Z",
    transform: "translate(-33.261 -1.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M51.42,2.957h.733v.615h.059a1.14,1.14,0,0,1,1.146-.683A1.251,1.251,0,0,1,54.69,4.323V6.817h-.758V4.5c0-.615-.27-.927-.834-.927a.88.88,0,0,0-.919.978V6.8H51.42V2.957Z",
    transform: "translate(-34.102 -1.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M58.94,4.877a1.824,1.824,0,1,1,3.632,0,1.825,1.825,0,1,1-3.632,0Zm2.848,0c0-.834-.379-1.323-1.037-1.323s-1.037.489-1.037,1.323S60.086,6.2,60.752,6.2,61.788,5.712,61.788,4.877Z",
    transform: "translate(-35.285 -1.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M64.46,2.957h.733v.615h.059A1.14,1.14,0,0,1,66.4,2.89,1.251,1.251,0,0,1,67.73,4.323V6.817h-.758V4.5c0-.615-.27-.927-.834-.927a.88.88,0,0,0-.919.978V6.8H64.46V2.957Z",
    transform: "translate(-36.153 -1.348)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1731",
    "data-name": "Group 1731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M21.2,6.632V5.874c0-.211,0-.43-.008-.64a8.531,8.531,0,0,0-.126-1.39A4.611,4.611,0,0,0,20.63,2.52a4.5,4.5,0,0,0-.817-1.129A4.349,4.349,0,0,0,18.683.573,4.611,4.611,0,0,0,17.36.135a9.691,9.691,0,0,0-1.39-.126c-.211,0-.421-.008-.64-.008H5.874c-.211,0-.43,0-.64.008a9.582,9.582,0,0,0-1.39.126A4.527,4.527,0,0,0,2.52.573,4.407,4.407,0,0,0,.573,2.52,4.527,4.527,0,0,0,.135,3.843a9.691,9.691,0,0,0-.126,1.39c0,.211-.008.43-.008.64v9.455c0,.211,0,.43.008.64a8.531,8.531,0,0,0,.126,1.39,4.611,4.611,0,0,0,.438,1.323,4.5,4.5,0,0,0,.817,1.129,4.349,4.349,0,0,0,1.129.817,4.291,4.291,0,0,0,1.323.438,9.691,9.691,0,0,0,1.39.126c.211.008.43.008.64.008h9.455c.211,0,.43,0,.64-.008a8.531,8.531,0,0,0,1.39-.126,4.611,4.611,0,0,0,1.323-.438,4.5,4.5,0,0,0,1.129-.817,4.349,4.349,0,0,0,.817-1.129,4.611,4.611,0,0,0,.438-1.323,9.691,9.691,0,0,0,.126-1.39c.008-.211.008-.43.008-.64v-8.7Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glyph_11_",
    transform: "translate(4.187 3.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1732",
    "data-name": "Group 1732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M15.773,3.84c-.051.008-.506.084-.565.093l-6.3,1.281h0a.861.861,0,0,0-.4.177.654.654,0,0,0-.211.4c0,.042-.008.11-.008.219V13.9a.75.75,0,0,1-.143.514.708.708,0,0,1-.463.236c-.135.025-.278.059-.413.084a6.733,6.733,0,0,0-1.163.295,1.989,1.989,0,0,0-.691.438,1.656,1.656,0,0,0-.438,1.315,1.638,1.638,0,0,0,1.289,1.449,2.708,2.708,0,0,0,1.138-.059,2.259,2.259,0,0,0,.733-.27,1.871,1.871,0,0,0,.581-.539,2.057,2.057,0,0,0,.312-.725,3.52,3.52,0,0,0,.067-.784V9.014c0-.371.1-.463.4-.531,0,0,5.242-1.053,5.486-1.1.337-.067.506.034.506.388v4.669a.761.761,0,0,1-.126.522.708.708,0,0,1-.463.236c-.135.025-.278.059-.413.084a6.733,6.733,0,0,0-1.163.295,1.989,1.989,0,0,0-.691.438,1.7,1.7,0,0,0-.455,1.315,1.664,1.664,0,0,0,.539,1.053,1.582,1.582,0,0,0,.767.388,2.708,2.708,0,0,0,1.138-.059,2.081,2.081,0,0,0,.733-.27,1.871,1.871,0,0,0,.581-.539,2.057,2.057,0,0,0,.312-.725,3.511,3.511,0,0,0,.059-.784V4.4C16.3,4.033,16.11,3.814,15.773,3.84Z",
    transform: "translate(-4.968 -3.838)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/apple-music.45d41f87.svg";
export { ForwardRef as ReactComponent };